export default (theme: Object) => ({
  assigneeInput: {
    width: 290,
    [theme.breakpoints.down('xs')]: {
      width: 200,
    },
  },
});
